import { render } from "./OtherSettingView.vue?vue&type=template&id=755566bc"
import script from "./OtherSettingView.vue?vue&type=script&lang=js"
export * from "./OtherSettingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__